import React from 'react';
import {
  Container,
  Header,
  Table
} from 'semantic-ui-react';

import AppContainer from './AppContainer';

/* eslint-disable react/no-multi-comp */
const Pricing = () => (
  <AppContainer>
    <Container text style={{marginTop:"3em"}}>
      <Header as="h1">Pricing</Header>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Number of Pages</Table.HeaderCell>
            <Table.HeaderCell>Size</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Prices</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>20</Table.Cell>
            <Table.Cell>8"x8"</Table.Cell>
            <Table.Cell>Soft cover</Table.Cell>
            <Table.Cell>$30</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>20</Table.Cell>
            <Table.Cell>8"x11" (Tall)</Table.Cell>
            <Table.Cell>Hard cover</Table.Cell>
            <Table.Cell>$40</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Container>
  </AppContainer>
);

export default Pricing;
